import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ViewTemplateService } from '../view-template.service';
import { FormService } from '../../form/form.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { AppService } from 'src/modules/base/shared/services/app.service';

@Component({
    selector: 'app-view-template',
    templateUrl: './view-template.component.html',
    styleUrls: ['./view-template.component.scss'],
    standalone: false
})
export class ViewTemplateComponent implements OnInit {
  templateField: any = false;
  id: any;
  resource: any;
  data: any = false;
  options: any;
  show: boolean = true;
  dropdownList: boolean = false;
  tempTemplate: any;
  rowData: any = {};
  status: any;
  reportStatus: any;
  observation_Id: string = "";
  btn = {
    "Add": []
  };
  config: any;
  constructor(private baservice: BaseService,
    private activatedRoute: ActivatedRoute,
    private formService: FormService,
    private ViewTemplateService: ViewTemplateService,
    private alerts: AlertsService,
    private router: Router,
    private appService: AppService) {
    this.id = this.activatedRoute.snapshot.params.id;
    this.resource = this.activatedRoute.snapshot.params.resource;
  }

  ngOnInit() {
    this.config = {
      "submitButton": true,
      "cancelButton": true,
      "filterForm": false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this.getFormData(this.id, this.resource);
  }
  getFormData(id, resource) {
    this.baservice.getById(id, resource).subscribe(x => {
      //status added to determine result provisioning/finalization
      this.status = x.resultEntryStatus;
      this.reportStatus = x.reportStatus;
      //for diagnostic test template
      if (x.serviceCode != undefined) {
        this.rowData = x;
        console.log("ResultEntryStatus for obs is::", x.resultEntryStatus);
        if (x.resultEntryStatus == 'pending') {
          if (x.serviceItemCode != undefined && x.serviceType_code != undefined) {
            this.getDataFromObsDef(x.serviceItemCode, x.serviceType_code);
          }
        }
        else {
          //wse have to get from observation for update
          this.getDataFromObs(x.serviceCode, x.facility_id, x.orderId);
        }
      }
      //for template engine
      else {
        this.setTemplate(x);
      }
    })
  }
  setTemplate(x) {
    this.templateField = {
      "blocks": x.blocks
    };
    this.show = true;
    this.data = true;
  }
  setTemplateMap(x) {
    if (x.resultType == 'dropdownlist') {
      this.dropdownList = true;
    }
    this.ViewTemplateService.getMappedData(x, (fields) => {
      this.templateField = fields;
      this.tempTemplate = this.templateField;
    });
  }
  //get data from observationdefinition --- (using servicecode)
  getDataFromObsDef(serviceItemCode, serviceType_code) {
    let serviceCodes = "serviceItemCode:" + serviceItemCode + ",serviceType_code:" + serviceType_code;
    this.baservice.get("GET_OBSERVATION_DEFINITION", serviceCodes, "observationdefinition", "", "").subscribe(x => {
      this.data = x.resource[0];
      this.setDropdownForTemplate(x.resource[0]);
      //hardcoded for advance text to be removed ASAP
      // let y = {
      //   "_id": "ccddb470-5d50-11ea-ac32-36b9ce57c8d7-14",
      //   "account_id": "6ad4e820-ffcc-11e9-a0e6-96e83143993f-37",
      //   "g_created_by_id": "905b2ea0-4f0f-11ea-9327-2a4a961ae664-71",
      //   "g_created_by_name": "Sushil  Gautam",
      //   "g_creation_time": ("1583241220409"),
      //   "g_soft_delete": "N",
      //   "id": "ccddb470-5d50-11ea-ac32-36b9ce57c8d7-14",
      //   "identifier": "",
      //   "facility_id": "a8190750-3c0f-11ea-ade5-2e3faaf737a6-86",
      //   "category": "pathology",
      //   "testName": "advanceText",
      //   "serviceCode": "advancetext",
      //   "department": "Pathology",
      //   "subDepartment": "Haematology",
      //   "cptCode": "",
      //   "loincCode": "",
      //   "snomedCode": "",
      //   "specimen": "urine",
      //   "sampleQuantity": "12",
      //   "sampleQuantityAndUnit": "12 ml",
      //   "serviceId": "5a089460-5d50-11ea-80da-8240273e54b7-77",
      //   "sampleQuantityUnit": "ml",
      //   "vacutainerTube": "Urine specimen container",
      //   "vacutainerTubeColor": "green",
      //   "labServiceType": "Test",
      //   "method": "Total measurement",
      //   "ispregnant": false,
      //   "time": false,
      //   "multipleResultsAllowed": false,
      //   "uniqueBarCodeRequired": false,
      //   "formulaTest": false,
      //   "isConfidential": false,
      //   "isOutSource": false,
      //   "outSourceCentre": "",
      //   "reportName": "advanceText",
      //   "testDescription": "",
      //   "resultType": "advancetext",
      //   "dropdown_list": "",
      //   "dropdown_status": "",
      //   "singlelineText": "",
      //   "singleline_status": "",
      //   "unit": "",
      //   "decimalPrecision": "",
      //   "note": "",
      //   "remarks": "",
      //   "interpretation": "",
      //   "advice": "",
      //   "impression": "",
      //   "advanceText": [
      //     {
      //       "gender": "male",
      //       "formatName": "male",
      //       "advancetext_status": "active",
      //       "advanceText": "<p>male</p>\n"
      //     },
      //     {
      //       "gender": "male",
      //       "formatName": "female",
      //       "advancetext_status": "active",
      //       "advanceText": "<p>female</p>\n"
      //     }
      //   ]
      // };
      if (x.blocks == undefined)
        this.setTemplateMap(x.resource[0]);
      // this.setTemplateMap(y);
      else
        this.setTemplate(x);
    })
  }
  //for update 
  getDataFromObs(serviceCode, facility_id, orderId) {
    let serviceCodes = "serviceCode:" + serviceCode + "," + "facility_id:" + facility_id + "," + "orderId:" + orderId;
    this.baservice.get("GET_ALL", "", "observation", "", serviceCodes).subscribe(x => {
      debugger;
      x.resource[0].component[0]['result'] = x.resource[0].component[0]['valueString'];
      this.data = x.resource[0].component[0];
      this.observation_Id = x.resource[0].id;
      this.setDropdownForTemplate(x.resource[0].component[0]);
      if (x.blocks == undefined)
        this.setTemplateMap(x.resource[0].component[0]);
      else
        this.setTemplate(x);
    })
  }
  setDropdownForTemplate(x) {
    let dataSourceFound = {
      application: "form-template-engine",
      resource: "template",
      query_id: "GET_ALL",
      filter: "kxCode:" + x['serviceCode']
    }
    this.formService.getDictionary(dataSourceFound.resource, dataSourceFound.query_id, dataSourceFound.application, dataSourceFound["args"] != undefined ? dataSourceFound["args"] : null, dataSourceFound.filter ? dataSourceFound.filter : null).subscribe(
      (data) => {
        this.options = data;
      });
  }
  valueChange(event) {
    let e = [];
    this.show = false;
    e = [...JSON.parse(event.target.value).blocks, ... this.tempTemplate.blocks];
    this.show = false;
    this.templateField = {
      "blocks": e
    };;
    setTimeout(() => { this.show = true; }, 250);
  }
  getVal(option) {
    return JSON.stringify(option);
  }
  onSaveFinished(event) {
    let result = Object.assign(this.rowData, this.data, event.result);
    let component =
    {
      "code": result['serviceCode'],
      "valueTime": result['timeresult'],
      "valueString": result['result'],
      "dataAbsentReason": "",
      "note": result['note'],
      "remarks": result['remarks'],
      "interpretation": result['interpretation'],
      "advice": result['advice'],
      "impression": result['impression'],
      "resultType": result['resultType'],
      "device": result['machine'],
      "serviceCode": result['serviceCode'],
      "method": result['method'],
      "name": result['testName'],
    }
    let e = {
      "id": this.observation_Id,
      "patientId": result['UHID'],
      "facility_id": result['facility_id'],
      "serviceCode": result['serviceCode'],
      "status": "",
      "serviceType": result['serviceType'],
      "orderId": result['orderId'],
      "accessionIdentifier": result['accessionIdentifier'],
      "partOf": "",
      "department": result['department'],
      "subDepartment": result['subDepartment'],
      "subject": result['subject'],
      "sampleQuantity": result['sampleQuantity'],
      "sampleDateTime": result['collectedDateTime'],
      "bodySite": "",
      "specimen": result['type'],
      "derivedFrom": "",
      "comments": "",
      "component": [component]
    }
    let diagnosticreport = {
      "id": "",
      "patientAge": result['age'],
      "IP_No": result['IP_No'],
      "patientGender": result['gender'],
      "patientName": result['patientName'],
      "patientType": result['patientType'],
      "referBy": result['referBy'],
      "uhid": result['UHID'],
      "serviceCode": result['serviceCode'],
      "category": result['serviceType'],
      "orderId": result['orderId'],
      "accessionIdentifier": result['accessionIdentifier'],
      "department": result['department'],
      "subDepartment": result['subDepartment'],
      "sampleDateTime": result['collectedDateTime'],
      "bodySite": "",
      "imagingStudy": "",
      "status": "",
      "specimen": result['type'],
      "conclusion": "",
      "result": [component]
    }

    //for add in each case

    this.baservice.action(e, 'add', 'diagnostic', "observation").subscribe((data: any) => {
      if (data.errCode == -1) {
        this.alerts.error(data.message);
      } else {
        this.alerts.success("Added Successfully");
        //for diagnostic test template
        if (this.rowData) {
          //list for control back--tab 
          this.router.navigateByUrl('/diagnostic/specimen_format/list?tab_0=result');
        }
        //for template
        else {
          this.router.navigateByUrl('/form-template-engine/template/list');
        }
        // this.router.navigate()
      }
    }, error => {
      this.alerts.error('API error');
    })

    //for update
    if (this.status == 'completed' && this.reportStatus == 'pending') {
      this.baservice.action(e, 'modify', 'diagnostic', 'observation').subscribe((data: any) => {
        if (data.errCode == -1) {
          // this.alerts.error(data.message);
        } else {
          this.alerts.success("Updated Successfully");
          this.callDiag(diagnosticreport);
          //for diagnostic test template
          if (this.rowData) {
            this.router.navigateByUrl('/diagnostic/specimen_format/list?tab_0=completed');
          }
          //for template
          else {
            this.router.navigateByUrl('/form-template-engine/template/list');
          }
          // this.router.navigate()
        }
      }, error => {
        this.alerts.error('API error');
      })

    }
  }
  callDiag(diagnosticreport) {
    //for diagnosticreport add
    this.baservice.action(diagnosticreport, 'add', 'diagnostic', 'diagnosticReport').subscribe(e => {
    })
  }
  redirect() {
    this.router.navigateByUrl('/form-template-engine/templateDiagnostic/list');
  }

  goBack() {
    if (this.activatedRoute.snapshot.queryParams.hasOwnProperty('returnUrl') && this.activatedRoute.snapshot.queryParams.hasOwnProperty('tab')) {
      window.location.reload();
    } else if (this.activatedRoute.snapshot.queryParams.hasOwnProperty('returnUrl')) {
      this.router.navigateByUrl(this.activatedRoute.snapshot.queryParams.returnUrl);
    } else {
      let current = (this.activatedRoute.snapshot.data.view == undefined) ? this.activatedRoute.snapshot.data.resource : this.activatedRoute.snapshot.data.view;
      const url = '/' + this.appService.getApplication() + '/' + current + '/list';
      this.router.navigate([url]);
    }
  }
}